import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SlidePanelContainerComponent } from "./slide-panel-container.component";
import { SlidePanelLeftDirective } from "./slide-panel.directive";
import { SlidePanelDirective, SlidePanelRightDirective, SlidePanelRightLazyDirective } from "./slide-panel.directive";
import { CdkPortalOutlet } from "@angular/cdk/portal";
import { SlidePanelComponent } from "./slide-panel.component";

const components = [
    SlidePanelContainerComponent,
    SlidePanelComponent,
    SlidePanelDirective, 
    SlidePanelLeftDirective, 
    SlidePanelRightDirective, 
    SlidePanelRightLazyDirective
];
@NgModule({
    imports: [
      CommonModule,
      CdkPortalOutlet
    ],
    declarations: [components],
    exports: [components]
  })
export class SlidePanelModule {}